import { yup } from '@framework/validation';
import React from 'react';
import type { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps';
import { CommonContainerWidgetConfigSchema } from '../common/CommonContainerWidgetConfigSchema';
import type { IRowWidget } from './IRowWidget';

export const RowWidgetConfigSchema = CommonContainerWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Row).required(),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IRowWidget>;

export interface IRowWidgetConfigComponentProps
  extends IWidgetComponentProps<IRowWidget> {}

export function RowWidgetConfigComponent(
  props: IRowWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />
    </div>
  );
}
